import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "./config";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    setMessage("");
    setError(null);

    try {
      // Log in the user
      const res = await axios.post(`${API_BASE_URL}/login`, {
        username,
        password,
      });

      // Store the JWT token
      localStorage.setItem("token", res.data.token);
      setMessage("Login successful!");

      // Fetch the user's profile information
      const profileRes = await axios.get(`${API_BASE_URL}/profile`, {
        headers: {
          Authorization: `Bearer ${res.data.token}`,
        },
      });

      const { profilePic, tagline, bio } = profileRes.data;

      // Check if profile is incomplete
      if (!profilePic || !tagline || !bio) {
        // Redirect to Edit Profile page if profile is incomplete
        navigate("/edit-profile");
      } else {
        // Redirect to Home page if profile is complete
        navigate("/home");
      }
    } catch (err) {
      setError(err.response?.data?.error || "Login failed. Please try again.");
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center" style={{ 
      minHeight: "100vh",
      position: "relative"
    }}>
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: "url('/login-signup-background.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        filter: "blur(3px) brightness(0.8)",
        zIndex: -1
      }}></div>
      <div className="login-container" style={{ width: "100%", maxWidth: "400px", padding: "20px", position: "relative", zIndex: 1 }}>
        <div className="card shadow">
          <div className="card-body p-4">
            <h2 className="text-center mb-4">Login</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group mb-3">
                <label>Email</label>
                <input
                  type="text"
                  className="form-control"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter your email"
                  required
                />
              </div>
              <div className="form-group mb-3">
                <label>Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary w-100">
                Login
              </button>
            </form>

            {message && <p className="mt-3 text-center" style={{ color: "green" }}>{message}</p>}
            {error && <p className="mt-3 text-center" style={{ color: "red" }}>{error}</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
